(() => {
  const dialog = document.getElementById('ZPrivacyDialog');
  if (!dialog) return;
  const status = dialog.querySelector('[data-z-consent-status]');
  const choices = Array.from(dialog.querySelectorAll('[data-z-consent]'));
  let api = null;
  let opener = null;
  const message = (key) => dialog.dataset[key] || '';
  function populate() {
    if (!api) return;
    const current = api.currentVisitorConsent();
    choices.forEach(input => { input.checked = current[input.dataset.zConsent] === 'yes'; });
  }
  function open(trigger) {
    opener = trigger || null;
    populate();
    if (!api) status.textContent = message('loadingText');
    if (!dialog.open) dialog.showModal();
  }
  function close() {
    dialog.close();
    opener?.focus();
  }
  function save(value) {
    if (!api) { status.textContent = message('errorText'); return; }
    const consent = Object.fromEntries(choices.map(input => [input.dataset.zConsent, value === undefined ? input.checked : value]));
    status.textContent = message('savingText');
    api.setTrackingConsent(consent, result => {
      if (result?.error) { status.textContent = message('errorText'); return; }
      status.textContent = message('savedText');
      populate();
      close();
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-z-privacy-open]');
    if (trigger) open(trigger);
    if (event.target.closest('[data-z-privacy-close]')) close();
    const all = event.target.closest('[data-z-consent-all]');
    if (all) save(all.dataset.zConsentAll === 'true');
    if (event.target.closest('[data-z-consent-save]')) save();
  });
  function ready(error) {
    if (error || !window.Shopify?.customerPrivacy) { status.textContent = message('errorText'); return; }
    api = window.Shopify.customerPrivacy;
    populate();
    status.textContent = '';
    if (api.shouldShowBanner()) open();
  }
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
  else status.textContent = message('errorText');
})();
